// Artifact-template analytics enums; distinct from the chat writing-sample TemplateSource.

export enum ArtifactTemplateSource {
  Upload = 'upload',
  MatterFiles = 'matter_files',
}

export enum ArtifactExportType {
  Download = 'download',
  SaveToMatter = 'save_to_matter',
}

// Stage of the apply-template cycle that failed (normalized, no raw error messages)
export enum ArtifactTemplateApplyErrorType {
  CopyTemplate = 'copy_template_error',
  ApplyTemplate = 'apply_template_error',
  DeliverOutput = 'deliver_output_error',
}
